import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Wrench, Car } from 'lucide-react';
import AdAnalyticsPage from '@/pages/AdAnalyticsPage';
import ServicesAdAnalytics from '@/pages/ServicesAdAnalytics';

// Two businesses, two ad accounts, two funnels: Meta buys inspection leads, Google buys
// service leads. They share nothing but this page, so the channel switch lives here and
// each child owns its own data, filters and definitions.
const CHANNELS = [
  { key: 'inspections', label: 'Inspections', sub: 'Meta Ads', icon: Car },
  { key: 'services', label: 'Services', sub: 'Google Ads', icon: Wrench },
];

export default function AdsManagementPage() {
  const [params, setParams] = useSearchParams();
  const active = params.get('tab') === 'services' ? 'services' : 'inspections';

  const switcher = (
    <div className="inline-flex bg-gray-100 rounded-xl p-1 gap-1" data-testid="ads-channel-switcher">
      {CHANNELS.map((c) => {
        const Icon = c.icon;
        const on = active === c.key;
        return (
          <button
            key={c.key}
            onClick={() => setParams(c.key === 'services' ? { tab: 'services' } : {})}
            className={`px-4 py-2 rounded-lg text-sm flex items-center gap-2 transition-colors ${
              on ? 'bg-white shadow-sm text-gray-900' : 'text-gray-500 hover:text-gray-700'}`}
            data-testid={`ads-channel-${c.key}`}
          >
            <Icon className="h-4 w-4" />
            <span className="font-medium">{c.label}</span>
            <span className={`text-xs ${on ? 'text-gray-400' : 'text-gray-400'}`}>{c.sub}</span>
          </button>
        );
      })}
    </div>
  );

  if (active === 'services') {
    return (
      <div className="p-6 max-w-7xl mx-auto" data-testid="ads-management-services">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Ads Management</h1>
          <p className="text-gray-500 mt-1">
            Google Ads spend against the service funnel — lead to booking to cash
          </p>
          <div className="mt-4">{switcher}</div>
        </div>
        <ServicesAdAnalytics />
      </div>
    );
  }

  return <AdAnalyticsPage channelSwitcher={switcher} />;
}
